import api from '@/api';

const { $core, $pricing } = api;

export const { $types } = $pricing;
export const { $applications, $roles } = $core;
